import ToolBar from './ToolBar';
import { withI18n } from 'react-i18next';
export default withI18n()(ToolBar);
